import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import {
  addLeadAPI,
  getLeadAPI,
  deleteLeadAPI,
  EditLeadAPI,
  ViewLeadAPI,
  CreateLeadLogAPI,
  ConvertLeadApi,
  CloseLeadApi,
  getCloseLeadReasonsAPI,
  getCloseLeadsApi,
} from "./api"
import {
  addLeadSuccess,
  addLeadFailure,
  getLeadSuccess,
  getLeadFailure,
  deleteLeadSuccess,
  deleteLeadFailure,
  editLeadSuccess,
  editLeadFailure,
  viewLeadSuccess,
  viewLeadFailure,
  createleadlogFailure,
  convertLeadsSuccess,
  convertLeadsError,
  closeLeadSuccess,
  closeLeadFailure,
  getCloseLeadReasonSuccess,
  getCloseLeadReasonFailure,
  getLeadBlockedStart,
  getLeadBlockedSuccess,
  getLeadBlockedFailure,
} from "./action"
import {
  ADD_LEAD_START,
  GET_LEAD_START,
  DELETE_LEAD_START,
  EDIT_LEAD_START,
  VIEW_LEAD_START,
  CREATE_LEADLOG_START,
  CONVERT_LEAD_START,
  CLOSE_LEAD_START,
  GET_CLOSELEAD_REASON_START,
  GET_BLOCKED_LEAD_START,
} from "./actiontypes"

function* addLeadAsync(action) {
  try {
    const response = yield call(addLeadAPI, action.payload)
    if (response.status === 200 || 201) {
      yield put(addLeadSuccess(response.data))
    } else {
      throw response
    }
  } catch (error) {
    yield put(addLeadFailure(error.response.data || "Something error Occured please try again"))
  }
}
function* AddLead() {
  yield takeEvery(ADD_LEAD_START, addLeadAsync)
}

function* getLeadAsync(action) {
  console.log(action)
  try {
    const response = yield call(getLeadAPI, action.payload)
    if (response.status === 200) {
      delay(400)
      yield put(getLeadSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    console.log(error.response.data)
    yield put(getLeadFailure(error.response.data))
  }
}

function* GetLead() {
  yield takeEvery(GET_LEAD_START, getLeadAsync)
}

function* deleteLeadAsync(action) {
  try {
    const response = yield call(deleteLeadAPI, action)
    if (response.status === 200) {
      yield put(deleteLeadSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    console.log(error.response.data)
    yield put(deleteLeadFailure(error.response.data))
  }
}

function* DeleteLead() {
  yield takeEvery(DELETE_LEAD_START, deleteLeadAsync)
}

function* editLeadAsync(action) {
  try {
    const response = yield call(EditLeadAPI, action.payload)
    if (response.status === 200) {
      yield put(editLeadSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    console.log(error.response.data)
    yield put(editLeadFailure(error.response.data))
  }
}

function* EditLead() {
  yield takeEvery(EDIT_LEAD_START, editLeadAsync)
}

function* ViewLeadAsync(action) {
  try {
    const response = yield call(ViewLeadAPI, action.payload)
    if (response.status === 200) {
      delay(200)
      yield put(viewLeadSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(viewLeadFailure(error.response.data))
  }
}

function* ViewLead() {
  yield takeEvery(VIEW_LEAD_START, ViewLeadAsync)
}

// create lead log

function* CreateLeadLogAsync(action) {
  try {
    const response = yield call(CreateLeadLogAPI, action.payload)
    if (response.status === 200) {
      delay(200)
      yield put(viewLeadSuccess(response))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(createleadlogFailure(error.response))
  }
}

function* CreateLeadLog() {
  yield takeEvery(CREATE_LEADLOG_START, CreateLeadLogAsync)
}

function* ConvertLeadAsync(action) {
  try {
    const response = yield call(ConvertLeadApi, action.payload)
    if (response.status === 200) {
      delay(200)
      yield put(convertLeadsSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(convertLeadsError(error.data))
  }
}

function* ConvertLead() {
  yield takeEvery(CONVERT_LEAD_START, ConvertLeadAsync)
}

function* CloseLeadAsync(action) {
  try {
    const response = yield call(CloseLeadApi, action.payload)
    if (response.status === 200) {
      delay(200)
      yield put(closeLeadSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(closeLeadFailure(error.data))
  }
}

function* CloseLead() {
  yield takeEvery(CLOSE_LEAD_START, CloseLeadAsync)
}




function* getCloseLeadReasonAsync(action) {
  try {
    const response = yield call(getCloseLeadReasonsAPI, action.payload)
    if (response.status === 200) {
      yield put(getCloseLeadReasonSuccess(response.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    yield put(getCloseLeadReasonFailure(error.response.data))
  }
}

function* GetCloseLeadReason() {
  yield takeEvery(GET_CLOSELEAD_REASON_START, getCloseLeadReasonAsync)
}

// bloacked Leads

function* getLeadBlockedAsync() {
  try {
    const response = yield call(getCloseLeadsApi)
    if (response.status === 200) {
      delay(400)
      console.log(response)
      yield put(getLeadBlockedSuccess(response?.data?.data))
    } else {
      throw new Error(Response)
    }
  } catch (error) {
    console.log(error.response.data)
    yield put(getLeadBlockedFailure(error.response.data))
  }
}

function* GetLeadBlocked() {
  yield takeEvery(GET_BLOCKED_LEAD_START, getLeadBlockedAsync)
}
function* LeadSaga() {
  yield all([
    fork(AddLead),
    fork(GetLead),
    fork(DeleteLead),
    fork(EditLead),
    fork(ViewLead),
    fork(CreateLeadLog),
    fork(ConvertLead),
    fork(CloseLead),
    fork(GetCloseLeadReason),
    fork(GetLeadBlocked)
  ])
}
export default LeadSaga
